import { FunctionComponent } from 'react';
import Row from '@/components/layout/Row';
import Col from '@/components/layout/Col';
import SectionDivider from '@/components/landingPages/SectionDivider';
import Header from '@/components/typography/Header';
import Card from '@/components/design/Card';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';
import PrismicRichText from '@/components/design/PrismicRichText';
import styles from './LocationGuideSection.module.scss';

interface IProps {
  name: string;
  guide: IPrismicRichTextElement[];
}

const LocationGuideSection: FunctionComponent<IProps> = ({ name, guide }) => {
  const title = `Private Aircraft Charter to ${name} FAQ`;
  const question = `What do I need to think about when chartering to ${name}?`;
  return (
    <div className={styles.container} data-testid="LocationGuideSectionContainer">
      <Row gutter={[30, 0]}>
        <Col xs={12} sm={12} md={8} lg={7} xl={7}>
          <SectionDivider />
        </Col>
      </Row>
      <Row gutter={[30, 0]} style={{ marginTop: 10, marginBottom: 20 }}>
        <Col span={24}>
          <Header level={2} color="primary" strong marginBottom={2} style={{ marginTop: 10, marginBottom: 20 }}>
            {title}
          </Header>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {guide.map((item, index) => (
            <Card key={`${name}-guide-${index}`}>
              <Header level={5} strong color="primary">
                {question}
              </Header>
              <PrismicRichText items={guide} />
            </Card>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default LocationGuideSection;
